import React, { useState, useEffect } from 'react';
import { useSession } from '../session';
import './Footer.css';

export const Footer: React.FC = () => {
  const session = useSession();
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date: Date) => {
    return date.toUTCString().slice(17, 25) + ' UTC';
  };

  const getConnectionStatus = () => {
    if (session.loading) return { text: 'Connecting...', connected: false };
    if (session.error) return { text: 'Disconnected', connected: false };
    if (session.isAuthenticated) return { text: 'Connected', connected: true };
    return { text: 'Not Connected', connected: false };
  };

  const connectionStatus = getConnectionStatus();

  return (
    <footer className="footer">
      <div className="status-indicators">
        <div className="status-indicator">
          <div 
            className="status-dot" 
            style={{ 
              backgroundColor: connectionStatus.connected ? '#4ade80' : '#ef4444' 
            }}
          ></div>
          <span>{connectionStatus.text}</span>
        </div>
        <div className="status-indicator">
          <span>{formatTime(currentTime)}</span>
        </div>
      </div>
      <div>
        <button className="theme-toggle">🌙</button>
      </div>
    </footer>
  );
};

export default Footer;
